module.exports = __webpack_public_path__ + "imgs/preroll.dcc24705b8cea170d4773d6676fcf27e.jpg";